import 'animate.css';
import './index.less';
import { ANONYMOUS_USER_ID } from '@/shared/constants';
import { goToContactSales, setAnonymousUser } from '@/shared/utils/utils';
import { useConfigProvider } from '@/lib/context';
import { sendEventAnalyses } from '@/lib/service';
import { useRouter } from 'next/navigation';
import { EventName, EventSource } from '@/shared/constants/event';
import { ArrowRightOutlined } from '@pietra/icons';
import { motion } from 'framer-motion';
import CpuArchitecture from './background';
import React from 'react';
import storage from '@/shared/utils/storage';

const HomePageIntro = () => {
  const { isMobile } = useConfigProvider();

  const router = useRouter();

  const handleJoinPietra = () => {
    sendEventAnalyses({
      eventName: EventName.COMMON_VIEW,
      commonType: EventSource.HOMEPAGE,
      commonContent: 'join_pietra',
      sourceClient: isMobile ? 'mobile_web' : 'desktop_web',
      anonymousUserId: storage.get(ANONYMOUS_USER_ID) ?? setAnonymousUser(),
    });

    router.push('/sell-on-pietra/register');
  };

  const heroTitle = (
    <motion.div
      className="home-page-intro-header-wrap"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1 className="title">
        The <span className="gradient-text">AI platform</span> that knows your brand better than you
      </h1>
      <div className="subtitle">
        Unify your data, workflows, and execution across marketing, sourcing, and operations powered by AI.
      </div>
    </motion.div>
  );

  const cta = (
    <motion.div
      className="home-page-intro-cta-container"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.4 }}
    >
      <div className="create-account-button" onClick={handleJoinPietra}>
        <span className="text-content">
          Get started <span className="desktop-only">for free</span>
        </span>
        <ArrowRightOutlined style={{ color: '#fff' }} />
      </div>
      <div className="book-demo-button" onClick={goToContactSales}>
        Book a demo
      </div>
    </motion.div>
  );

  return (
    <div className="home-page-intro-wrap">
      <CpuArchitecture />
      <div className="content">
        {heroTitle}
        {cta}
      </div>
    </div>
  );
};

export default HomePageIntro;
